(function () {
  'use strict';

  var STORAGE_KEY = 'rp_favorites';

  function getFavorites() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setFavorites(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private mode, quota, etc.) - fail silently */
    }
  }

  function isFavorite(id, list) {
    list = list || getFavorites();
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return true;
    }
    return false;
  }

  function syncButton(btn) {
    var id = btn.getAttribute('data-product-id');
    var pressed = isFavorite(id);
    btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
  }

  function syncAllButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-favorite-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      syncButton(buttons[i]);
    }
  }

  function toggleFavorite(btn) {
    var id = btn.getAttribute('data-product-id');
    var list = getFavorites();
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) { idx = i; break; }
    }

    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({
        id: id,
        handle: btn.getAttribute('data-product-handle') || '',
        title: btn.getAttribute('data-product-title') || '',
        url: btn.getAttribute('data-product-url') || '#',
        price: btn.getAttribute('data-product-price') || '',
        image: btn.getAttribute('data-product-image') || ''
      });
    }

    setFavorites(list);

    var allButtonsForId = document.querySelectorAll('[data-favorite-toggle][data-product-id="' + cssEscape(id) + '"]');
    for (var j = 0; j < allButtonsForId.length; j++) {
      syncButton(allButtonsForId[j]);
    }

    renderFavoritesPage();
  }

  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return value.replace(/["\\]/g, '\\$&');
  }

  function renderFavoritesPage() {
    var grid = document.getElementById('favorites-grid');
    if (!grid) return;

    var emptyState = document.getElementById('favorites-empty');
    var list = getFavorites();

    if (list.length === 0) {
      grid.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }

    if (emptyState) emptyState.hidden = true;

    var html = list.map(function (item) {
      return (
        '<div class="favorites-item">' +
          '<a href="' + item.url + '" class="favorites-item__media" data-instant>' +
            (item.image
              ? '<img src="' + item.image + '" alt="" width="400" height="400" loading="lazy">'
              : '') +
          '</a>' +
          '<div class="favorites-item__info">' +
            '<a href="' + item.url + '" class="favorites-item__title" data-instant>' + item.title + '</a>' +
            '<p class="favorites-item__price">' + item.price + '</p>' +
          '</div>' +
          '<button type="button" class="favorites-item__remove" data-favorite-remove="' + item.id + '">Kaldır</button>' +
        '</div>'
      );
    }).join('');

    grid.innerHTML = html;
  }

  document.addEventListener('click', function (event) {
    var toggleBtn = event.target.closest && event.target.closest('[data-favorite-toggle]');
    if (toggleBtn) {
      event.preventDefault();
      toggleFavorite(toggleBtn);
      return;
    }

    var removeBtn = event.target.closest && event.target.closest('[data-favorite-remove]');
    if (removeBtn) {
      event.preventDefault();
      var id = removeBtn.getAttribute('data-favorite-remove');
      var list = getFavorites().filter(function (item) { return item.id !== id; });
      setFavorites(list);
      syncAllButtons();
      renderFavoritesPage();
    }
  });

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-favorite-toggle]')) syncButton(node);
        if (node.querySelectorAll) syncAllButtons(node);
      }
    }
  });

  function init() {
    syncAllButtons();
    renderFavoritesPage();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
